import React, { useState, useRef } from 'react'
import AudioGrid from "../components/AudioGrid"
import '../styles/blob.scss'

import {useSpring, animated} from 'react-spring'

export default function Blob({children}) {

  let [mouseX, setMouseX] = useState()
  let [mouseY, setMouseY] = useState()
  let [flicker, setFlicker] = useState(false)
  let blobHolderRef = useRef()

  const mouseMove = (e) => {
    setMouseX(e.pageX)
    setMouseY(e.pageY)
    setBlobPos({xy: [ e.pageX, e.pageY]})
  }

  const trans = (x, y) => `translate(${x - 300}px, ${y - 300}px)`

  const [blobPos, setBlobPos] = useSpring(() => ({ xy: [300, 300], config: { mass: 30, tension: 500, friction: 100 } }))

  return (
    <div className="blobHolder" ref={blobHolderRef}  onPointerMove={(e)=>mouseMove(e)} onMouseMove={(e)=>mouseMove(e)}>

      <AudioGrid setFlicker={setFlicker} />
      {children}
      <div className="blob">
        <animated.svg width="600" height="600" className={flicker ? 'flicker' : undefined} viewBox="0 20 600 600" style={{ transform: blobPos.xy.interpolate(trans) }} >
           <filter id="filter" x="-20%" y="-20%" width="140%" height="140%" filterUnits="objectBoundingBox" primitiveUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
	        <feGaussianBlur stdDeviation="50 50" x="0%" y="0%" width="110%" height="110%" in="SourceGraphic" edgeMode="none" result="blur"/>
          </filter>
          <path filter="url(#filter)">
            <animate attributeName="d" dur="2s" repeatCount="indefinite" 
              values="M431.3 121.9c22 40.1 11.3 97.5 13.3 146.9 2 49.5 16.6 91.1 4.3 121.8-12.2 30.6-51.3 50.4-88.5 55.1-37.1 4.7-72.4-5.7-108.8-17.1-36.5-11.3-74.1-23.7-104-52-29.9-28.2-52-72.4-48.4-115.4 3.5-43 32.7-84.8 70.5-122.2 37.7-37.3 84-70.2 134.5-75.1 50.4-5 105.1 17.9 127.1 58z;
              
                      M404.4 176.7c20.9 16.4 20.8 58.8 38.8 106.2 18.1 47.4 54.4 99.7 40.9 123.6-13.5 23.9-76.7 19.3-131.6 40.4-54.8 21-101.2 67.7-150.5 71.7-49.4 4.1-101.7-34.5-107.8-81.9C88 389.2 128 333 144.2 278c16.2-55.1 8.5-108.8 30.5-125 22-16.1 73.7 5.5 120.4 11.3 46.7 5.9 88.5-3.9 109.3 12.4z;
                      
                      M431.3 121.9c22 40.1 11.3 97.5 13.3 146.9 2 49.5 16.6 91.1 4.3 121.8-12.2 30.6-51.3 50.4-88.5 55.1-37.1 4.7-72.4-5.7-108.8-17.1-36.5-11.3-74.1-23.7-104-52-29.9-28.2-52-72.4-48.4-115.4 3.5-43 32.7-84.8 70.5-122.2 37.7-37.3 84-70.2 134.5-75.1 50.4-5 105.1 17.9 127.1 58z;" />
          </path>

        </animated.svg>

      </div>
    </div>
  )
}
